// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgBriefcase2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 4.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V5h-5v-.25ZM6 5v-.25A2.75 2.75 0 0 1 8.75 2h2.5A2.75 2.75 0 0 1 14 4.75V5h1.25A2.75 2.75 0 0 1 18 7.75v7.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-7.5A2.75 2.75 0 0 1 4.75 5H6Zm6.5 1.5h-5v10h5v-10Zm1.5 10v-10h1.25c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H14Zm-8 0H4.75c-.69 0-1.25-.56-1.25-1.25v-7.5c0-.69.56-1.25 1.25-1.25H6v10Z"
    />
  </svg>
)

export default SvgBriefcase2
